import Flickity from 'flickity';
import 'flickity/css/flickity.css';

(function (Drupal) {
  Drupal.behaviors.contactCardsClinics = {
    attach: function (context, settings) {
      let flkty;
      const deviceDetect = {
        breakpoint: 992,
        sliderSelector: '.contact-cards-clinics .view-content',
        isMobile: () => {
          return window.matchMedia(`(max-width: ${deviceDetect.breakpoint}px)`).matches;
        },
      };

      function initSlider() {
        const sliders = document.querySelectorAll(deviceDetect.sliderSelector);
        sliders.forEach((slider) => {
          if (slider && !flkty) {
            flkty = new Flickity(slider, {
              cellAlign: 'left',
              contain: true,
              groupCells: true,
              autoPlay: 2500,
              pageDots: true,
            });
          }
        });
      }

      // Función para destruir el slider
      function destroySlider() {
        if (flkty && typeof flkty.destroy === 'function') {
          flkty.destroy();
          flkty = null;
        }
      }

      // Verifica el tamaño de la ventana y activa/desactiva el slider
      function checkSlider() {
        if (window.innerWidth < deviceDetect.breakpoint) {
          initSlider();
        } else {
          destroySlider();
        }
      }

      // Ejecuta la función al cargar la página y al redimensionar la ventana
      window.addEventListener('load', checkSlider);
      window.addEventListener('resize', checkSlider);
    }
  }
})(Drupal);
